import { render } from "./MyServices.vue.js?vue&type=template&id=07b8d200!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyServices.vue?vue&type=template&id=07b8d200"
import script from "./MyServices.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyServices.vue?vue&type=script&lang=js"
export * from "./MyServices.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyServices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/settings/MyServices.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07b8d200"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07b8d200', __exports__)) {
    api.reload('07b8d200', __exports__)
  }
  
  module.hot.accept("./MyServices.vue.js?vue&type=template&id=07b8d200!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyServices.vue?vue&type=template&id=07b8d200", () => {
    api.rerender('07b8d200', render)
  })

}


export default __exports__